import router from './router'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { getAccessToken } from '@/utils/auth'
import { isRelogin } from '@/utils/request'

NProgress.configure({ showSpinner: false })

const whiteList = ['/login', '/index', '/auth-redirect', '/bind', '/register', '/oauthLogin/gitee']

router.beforeEach((to, from, next) => {
    NProgress.start()
    const isAuthenticated = localStorage.getItem('isAuthenticated') === 'true'; // 检查用户是否登录
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth); // 检查目标路由是否需要登录

    if (getAccessToken()) {
        if (to.path === '/login') {
            next({ path: '/' })
            NProgress.done()
        } else {
            if (store.getters.userId === 0) {
                isRelogin.show = true
                // 判断当前用户是否已拉取完 user_info 信息
                store.dispatch('user/GetInfo').then(userInfo => {
                    isRelogin.show = false
                    next()
                }).catch(err => {
                    store.dispatch('user/LogOut').then(() => {
                        Message.error(err)
                        next({ path: '/' })
                    })
                })
            } else {
                // // 监听前进、后退
                // // 如果从 chapterQuestion 或 quiuzQuestion 页面离开
                // var needConfirm = false;
                // if (from.name === 'chapterQuestion' || from.name === 'quiuzQuestion') {
                //     // 设置一个标志位，是否需要确认
                //     needConfirm = true;
                // } else {
                //     needConfirm = false;
                // }

                // // 如果需要确认
                // if (needConfirm) {
                //     const answer = window.confirm('确定要离开当前练习页面吗？未提交的内容将丢失。');
                //     if (!answer) {
                //         return next(false); // 中断导航
                //     }
                // }

                next()
            }
        }
    } else {
        if (requiresAuth && !isAuthenticated) {
            // 如果需要登录但未登录，跳转到登录页面
            next({ path: '/login', query: { redirect: to.fullPath } });
        } else {
            // 否则正常跳转
            next();
        }
        // 没有token
        if (whiteList.indexOf(to.path) !== -1) {
            // 在免登录白名单，直接进入
            next()
        } else {
            const redirect = encodeURIComponent(to.fullPath) // 编码 URI，保证参数跳转回去后，可以继续带上
            next(`/login?redirect=${redirect}`) // 否则全部重定向到登录页
            NProgress.done()
        }
    }
})

router.afterEach(() => {
    NProgress.done()
})
